/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 17:44:42 
 * @Last Modified by:   syyoon@yongtrim.com 
 * @Last Modified time: 2018-07-09 17:44:42 
 */
import _ from 'lodash';

import * as AuthActions from './auth.action';

export function authReducer(state = {}, action: AuthActions.All) {

  switch (action.type) {
   
    case AuthActions.LOGIN:
      return {
        loading: true
      }
    case AuthActions.LOGIN_SUCCESS:
      return {
        user: action['user'],
        login: true,
      };

    case AuthActions.TRYLOGIN:
      return {
        loading: true
      };
    case AuthActions.TRYLOGIN_SUCCESS:
      return {
        user: action['user'],
        login: true,
      };

    case AuthActions.LOGOUT:
      return {}


    case AuthActions.UPDATE_AUTH_RECEIVED:
      return getStateAfterUpdate(state, action['user']);

    default:
      return state;
  }
}

function getStateAfterUpdate(state, user) {
  if (state.user && state.user._id === user._id) {
    state.user = user;
  }
  return _.cloneDeep(state);
}



// WEBPACK FOOTER //
// ./src/store/auth/auth.reducer.ts